import {
  API_URL,
  store
} from '../index'
import axios from 'axios/index'

/* import error handler */
import ErrorHandler from '../ErrorHandler'

/* private UsersSettings Types */
import {
  Settings,
  _UsersSettings
} from '../namespace-helper'

import _ from 'lodash'

const selectedUserTemplate = {
  id: 0,
  name: '',
  email: '',
  role: 'member',
  password: '',
  accounts: [
    {
      firstname: null,
      lastname: null
    }
  ]
}

export default {
  namespaced: true,
  state: {
    users: [],
    allUsers: [],
    allUserRoles: [],
    selectedUser: _.cloneDeep(selectedUserTemplate),
    openNewUsersDialog: false
  },
  mutations: {
    [_UsersSettings.mutations.setUsers] (state, payload) {
      state.users = payload
    },
    [_UsersSettings.mutations.setAllUsers] (state, payload) {
      state.allUsers = payload
    },
    [_UsersSettings.mutations.setAllUserRoles] (state, payload) {
      state.allUserRoles = payload
    },
    [_UsersSettings.mutations.setSelectedUser] (state, payload) {
      if (payload !== null) {
        state.selectedUser = payload
      } else {
        state.selectedUser = _.cloneDeep(selectedUserTemplate)
      }
    },
    [_UsersSettings.mutations.setOpenCloseNewUserDialogState] (state) {
      state.openNewUsersDialog = !state.openNewUsersDialog
    }
  },
  actions: {
    [_UsersSettings.actions.saveUser] (context, payload) {
      store.commit(Settings.mutations.setLoading, true)

      const data = JSON.stringify(payload)

      if (payload.id === 0) {
        var url = API_URL + '/api/v1/users'

        axios.post(url, data, {
          headers: {
            'Content-Type': 'application/json',
            Authorization: 'Bearer ' + store.getters.getBearerToken
          }
        }
        ).then(function (r) {
          store.commit(Settings.mutations.setLoading, false)
          ErrorHandler.clear(store)
        }, function (err) {
          ErrorHandler.handleApiError(store, err)
        }).catch(e => console.error('#### ' + e))
      } else {
        url = API_URL + '/api/v1/users/' + payload.id

        axios.put(url, data, {
          headers: {
            'Content-Type': 'application/json',
            Authorization: 'Bearer ' + store.getters.getBearerToken
          }
        }
        ).then(function (r) {
          store.commit(Settings.mutations.setLoading, false)
          ErrorHandler.clear(store)
        }, function (err) {
          ErrorHandler.handleApiError(store, err)
        }).catch(e => console.error('#### ' + e))
      }
    },
    [_UsersSettings.actions.loadUsers] (context, payload) {
      console.log('loadUsers: ' + JSON.stringify(payload))
      console.log('loadUsers: ' + payload.sortBy + ' ' + payload.descending + ' ' + payload.page + ' ' + payload.limit)

      var url = API_URL + '/api/v1/users?limit=' + payload.limit + '&page=' + payload.page + '&search=' + payload.search + '&searchFields=id:like;name:like;role:like&orderBy=' + payload.sortBy + '&sortedBy=' + payload.descending

      store.commit(Settings.mutations.setLoading, true)

      return axios.get(url, {
        headers: {
          'Content-Type': 'application/json',
          Authorization: 'Bearer ' + store.getters.getBearerToken
        }
      }
      ).then(function (r) {
        store.commit(Settings.mutations.setLoading, false)
        ErrorHandler.clear(store)
        context.commit(_UsersSettings.mutations.setUsers, r.data.data)
      }, function (err) {
        ErrorHandler.handleApiError(store, err)
      }).catch(e => console.error('#### ' + e))
    },
    [_UsersSettings.actions.loadAllUsers] (context, payload) {
      var url = API_URL + '/api/v1/users'

      store.commit(Settings.mutations.setLoading, true)

      return axios.get(url, {
        headers: {
          'Content-Type': 'application/json',
          Authorization: 'Bearer ' + store.getters.getBearerToken
        }
      }
      ).then(function (r) {
        store.commit(Settings.mutations.setLoading, false)
        ErrorHandler.clear(store)
        context.commit(_UsersSettings.mutations.setAllUsers, r.data.data)
      }, function (err) {
        ErrorHandler.handleApiError(store, err)
      }).catch(e => console.error('#### ' + e))
    },
    [_UsersSettings.actions.loadAllUserRoles] (context, payload) {
      var url = API_URL + '/api/v1/userRoles'

      store.commit(Settings.mutations.setLoading, true)

      return axios.get(url, {
        headers: {
          'Content-Type': 'application/json',
          Authorization: 'Bearer ' + store.getters.getBearerToken
        }
      }
      ).then(function (r) {
        store.commit(Settings.mutations.setLoading, false)
        ErrorHandler.clear(store)
        context.commit(_UsersSettings.mutations.setAllUserRoles, r.data.data)
      }, function (err) {
        ErrorHandler.handleApiError(store, err)
      }).catch(e => console.error('#### ' + e))
    },
    [_UsersSettings.actions.openCloseNewUserDialog] ({ commit }) {
      commit(_UsersSettings.mutations.setOpenCloseNewUserDialogState)
    },
    [_UsersSettings.actions.setSelectedUser] ({ commit }, payload) {
      commit(_UsersSettings.mutations.setSelectedUser, payload)
    },
    [_UsersSettings.actions.resetState] ({ commit }, payload) {
      commit(_UsersSettings.mutations.setUsers, [])
      commit(_UsersSettings.mutations.setAllUsers, [])
      commit(_UsersSettings.mutations.setAllUserRoles, [])
      commit(_UsersSettings.mutations.setSelectedUser, null)
    }
  },
  getters: {
    [_UsersSettings.getters.users] (state) {
      return state.users
    },
    [_UsersSettings.getters.getAllUsers] (state) {
      return state.allUsers
    },
    [_UsersSettings.getters.getAllUserRoles] (state) {
      return state.allUserRoles
    },
    [_UsersSettings.getters.getOpenNewUserDialogState] (state) {
      return state.openNewUsersDialog
    },
    [_UsersSettings.getters.getSelectedUser] (state) {
      return state.selectedUser
    }

  }
}



// WEBPACK FOOTER //
// ./src/store/Settings/users.js